import RaisedButton from 'material-ui/RaisedButton';
import {TextInput} from '../../shared/components';

import {Card, CardActions, CardText} from 'material-ui/Card';
import {List, Map} from 'immutable';
import React, {PropTypes} from 'react';

export default function RequestPasswordResetForm({model, onFieldChange, onSubmit, submitting}) {
  return (
    <div className="request-password-reset-container">
      <div className="title">Enter your email</div>
      <Card zDepth={1}>
        <form onSubmit={onSubmit} className="request-password-reset-form">
          <CardText>
            <div disabled={submitting} className="body">
              <TextInput id="email" value={model.get('email')} floatingLabelText="Email" onChange={onFieldChange} />
            </div>
          </CardText>
          <CardActions className="actions">
            <RaisedButton
              style={{fontSize: 14, fontWeight: 700}}
              className="raised-button--rounded"
              type="submit"
              secondary
              disabled={submitting || !model.get('email')}>{submitting ? 'Submitting...' : 'Submit'}</RaisedButton>
          </CardActions>
        </form>
      </Card>
    </div>
  );
}

RequestPasswordResetForm.propTypes = {
  model: PropTypes.instanceOf(Map).isRequired,
  onFieldChange: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/passwordManagement/components/RequestPasswordResetForm.js